import { fetchClient } from '@/util/fetchClient';

/**
 * Update the current user's password.
 *
 * Calls POST /v2/users/me/update-password to set a new password
 * without requiring the old one.
 */
export async function updatePassword(newPassword: string) {
  const { data } = await fetchClient.POST('/v2/users/me/update-password', {
    body: { newPassword },
  });

  return data;
}
